"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFundingCountdown = void 0;
var _react = require("react");
var _reactRedux = require("react-redux");
var _futuresInstrumentsSelector = require("../../redux/futures/selectors/futuresInstrumentsSelector");
var _futuresLevel1Actions = require("../../redux/futures/actions/futuresLevel1Actions");
var _helpers = require("./helpers");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var useFundingCountdown = exports.useFundingCountdown = function useFundingCountdown() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var instrumentFundingCountdownValue = (0, _reactRedux.useSelector)(_futuresInstrumentsSelector.futuresInstrumentFundingCountdownSelector);
  var initialMilliseconds = Math.floor(instrumentFundingCountdownValue);
  var _useState = (0, _react.useState)(initialMilliseconds),
    _useState2 = _slicedToArray(_useState, 2),
    remainingTime = _useState2[0],
    setRemainingTime = _useState2[1];
  (0, _react.useEffect)(function () {
    // Reset timer when countdown value updates
    setRemainingTime(initialMilliseconds);
  }, [initialMilliseconds]);
  (0, _react.useEffect)(function () {
    var intervalId = setInterval(function () {
      setRemainingTime(function (prev) {
        var next = prev - 1000;
        if (next <= 0) {
          clearInterval(intervalId);
          dispatch((0, _futuresLevel1Actions.getAllFuturesLevel1Data)());
          return 0;
        }
        return next;
      });
    }, 1000);
    return function () {
      return clearInterval(intervalId);
    };
  }, [dispatch, initialMilliseconds]);
  return {
    fundingCountdown: (0, _helpers.formatTimerValue)(remainingTime)
  };
};